import { render, staticRenderFns } from "./NewContragents.vue?vue&type=template&id=37da5148&"
import script from "./NewContragents.vue?vue&type=script&lang=js&"
export * from "./NewContragents.vue?vue&type=script&lang=js&"
import style0 from "./NewContragents.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports